import {
	fetch
} from "./fetch";
import url from './url';

export function getDetail(id) {
	return fetch({
		url: `${url.detail}${id}/`,
		method: 'get',
	})
}
